var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLasuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.923 12.7716C13.7897 8.69369 7.47683 4.02657 14.2695 0.474242C14.5123 0.347167 14.4082 -0.0167302 14.1365 0.000598205C14.1365 0.000598205 -0.564538 0.191211 5.44192 9.68718C5.46504 9.72762 5.49395 9.76805 5.51707 9.80848C5.53442 9.83736 5.55176 9.86047 5.5691 9.88935C8.55209 14.5276 15.4835 19.4373 9.33831 23.4459C9.0666 23.625 9.22847 24.0524 9.54643 23.9947C16.553 22.7644 22.2068 19.2929 16.923 12.7716ZM17.2062 17.7622C16.923 19.3911 15.443 20.7369 12.8069 21.7766C14.9979 18.8655 12.223 15.6019 10.1245 13.176C6.85248 9.42148 2.59189 3.49516 10.0205 1.83163C10.165 1.79698 10.2748 1.96449 10.1939 2.08578C6.53453 7.41716 18.1717 12.5637 17.2062 17.7622Z",
    fill: "#5F5DF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLasuLogo);
export default __webpack_public_path__ + "static/media/LasuLogo.a3e341bcaa366aace2f2286237216d19.svg";
export { ForwardRef as ReactComponent };